import { render, staticRenderFns } from "./SpecialOfferReceiptFormTable.vue?vue&type=template&id=524a065e&"
import script from "./SpecialOfferReceiptFormTable.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferReceiptFormTable.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferReceiptFormTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports